/**
 * Header behaviour
 *
 * - Sticky: IntersectionObserver on a sentinel element (no scroll event)
 * - Mobile menu toggle
 * - Submenu expand buttons
 * - Brand dropdown (right-click)
 * - Transparent header: removed once user scrolls past threshold
 */

(function () {
    'use strict';

    // ── Element refs ──────────────────────────────────────────────────────────

    const header      = document.querySelector('.header');
    const headerNav   = document.querySelector('.header-nav');
    const mobileToggle = document.querySelector('.mobile-toggle');

    if (!header) return; // guard: header must exist

    // ── Sticky behaviour ──────────────────────────────────────────────────────
    // Transparent mode: header is position:fixed, so we watch scrollY directly.
    // Solid mode: header is position:sticky, so we use IntersectionObserver
    // on a sentinel element — no scroll event needed.

    if ( header.classList.contains('header--transparent') ) {

        const onScroll = () => {
            header.classList.toggle('is-sticky', window.scrollY > 0);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // set correct state on load

    } else {

        const sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
        document.body.insertBefore(sentinel, document.body.firstChild);

        const stickyObserver = new IntersectionObserver(
            ([entry]) => {
                header.classList.toggle('is-sticky', !entry.isIntersecting);
            },
            { threshold: 0 }
        );

        stickyObserver.observe(sentinel);
    }

    // ── Mobile menu toggle ────────────────────────────────────────────────────

    if (mobileToggle && headerNav) {
        mobileToggle.addEventListener('click', () => {
            const isOpen = headerNav.classList.toggle('menu-open');
            header.classList.toggle('has-open-menu', isOpen);
            mobileToggle.classList.toggle('is-active', isOpen);
            mobileToggle.setAttribute('aria-expanded', String(isOpen));
        });
    }

    // ── Submenu expand buttons (mobile accordion) ─────────────────────────────

    document.querySelectorAll('.header__menu__btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const isExpanded = btn.classList.toggle('expanded');
            btn.setAttribute('aria-expanded', String(isExpanded));
        });
    });

    // ── Brand / logo dropdown (right-click) ───────────────────────────────────

    const branding = document.querySelector('.header-branding');
    const logoDropdown = document.querySelector('.logo-dropdown');

    if (branding && logoDropdown) {
        branding.addEventListener('contextmenu', e => {
            if (!branding.classList.contains('show-dropdown')) return;
            e.preventDefault();
            const isOpen = logoDropdown.classList.toggle('open');
            logoDropdown.setAttribute('aria-hidden', String(!isOpen));
        });

        document.addEventListener('click', e => {
            if (!branding.contains(e.target) && logoDropdown.classList.contains('open')) {
                logoDropdown.classList.remove('open');
                logoDropdown.setAttribute('aria-hidden', 'true');
            }
        });
    }

})();